<template>
	<div class="t-login">
		<div class="t-login-card">
			<div class="t-logo-big">TaskFlow</div>
			<div class="t-tag">איפוס סיסמה</div>

			<template v-if="state === 'form'">
				<label>סיסמה חדשה</label>
				<input v-model="password" type="password" placeholder="לפחות 6 תווים" @keyup.enter="submit" />

				<label>אישור סיסמה</label>
				<input v-model="confirm" type="password" placeholder="הקלד שוב" @keyup.enter="submit" />

				<div v-if="error" class="t-error">{{ error }}</div>

				<button class="t-btn primary" :disabled="loading" @click="submit">
					{{ loading ? "מעדכן..." : "עדכן סיסמה" }}
				</button>
			</template>

			<template v-else-if="state === 'success'">
				<div style="text-align:center; padding:20px 0;">
					<div style="font-size:48px;">✅</div>
					<p style="font-weight:700; margin:14px 0 6px;">הסיסמה עודכנה בהצלחה</p>
					<p style="color:#676879; font-size:13px;">ניתן להתחבר כעת עם הסיסמה החדשה</p>
				</div>
				<router-link to="/tasks/login" class="t-btn primary" style="display:flex; justify-content:center; text-decoration:none; margin-top:10px;">להתחברות</router-link>
			</template>

			<template v-else>
				<div class="t-error" style="margin-top:14px;">{{ initialError }}</div>
				<router-link to="/tasks/login" class="t-btn ghost" style="display:flex; justify-content:center; text-decoration:none; margin-top:14px;">חזרה להתחברות</router-link>
			</template>
		</div>
	</div>
</template>

<script>
import { TasksAPI } from "./TasksApi";

export default {
	name: "TasksReset",
	inheritAttrs: false,
	data() {
		return {
			state: "form", // 'form' | 'success' | 'error'
			token: "",
			password: "",
			confirm: "",
			loading: false,
			error: "",
			initialError: "",
		};
	},
	created() {
		this.token = this.$route.query.token || "";
		if (!this.token) {
			this.state = "error";
			this.initialError = "קישור איפוס לא תקין";
		}
	},
	methods: {
		async submit() {
			this.error = "";
			if (this.password.length < 6) { this.error = "הסיסמה חייבת להכיל לפחות 6 תווים"; return; }
			if (this.password !== this.confirm) { this.error = "הסיסמאות לא תואמות"; return; }
			this.loading = true;
			const res = await TasksAPI.resetPassword(this.token, this.password);
			this.loading = false;
			if (res && res.status === "ok") {
				this.state = "success";
				return;
			}
			const map = {
				invalid_token: "הקישור לא תקף",
				expired:       "הקישור פג תוקף, בקש מייל חדש",
				invalid_input: "סיסמה לא תקינה (לפחות 6 תווים)",
			};
			this.error = map[res?.error] || "שגיאה בעדכון הסיסמה";
		},
	},
};
</script>
